var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-pagination',{attrs:{"value":_vm.page,"total-rows":_vm.totalRows,"per-page":_vm.perPage,"align":"center","first-text":"First","last-text":"Last","size":"sm"},on:{"change":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }